/** Bridges the editor's partial `FormDefinition` shape and the full envelope
 * the backend's `form.schema.json` requires (form_id, form_key, form_version,
 * title, instance_type, fields, ...). On accept, the backend returns
 * `updated_form` as the same envelope — we strip it back to the editor's
 * `{fields, conditional_rules, calculated_fields}` shape before applying.
 *
 * Kept outside `api/` because it's a pure data transformer with no I/O — the
 * api client never sees raw `FormDefinition`; only callers do.
 */
import type { FormDefinition } from '@/features/form-builder/api/form-builder-api'

export interface AssistantFormEnvelopeArgs {
  formId: string
  formKey: string
  formTitle: string
  instanceType: 'single' | 'repeatable'
  publishedVersionLabel?: string | null
  definition: FormDefinition
}

export function buildFormEnvelope({
  formId, formKey, formTitle, instanceType, publishedVersionLabel, definition,
}: AssistantFormEnvelopeArgs) {
  return {
    form_id: formId,
    form_key: formKey,
    form_version: publishedVersionLabel ?? '1.0',
    title: { fa: formTitle || formKey },
    instance_type: instanceType,
    fields: definition.fields,
    conditional_rules: definition.conditional_rules,
    calculated_fields: definition.calculated_fields,
    steps: [],
  }
}

export function unwrapEnvelope(envelope: any): FormDefinition {
  return {
    fields: envelope?.fields ?? [],
    conditional_rules: envelope?.conditional_rules ?? [],
    calculated_fields: envelope?.calculated_fields ?? [],
  }
}
